import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { animations } from "../../animations/animations";
import Swal from "sweetalert2";

//imgs
import sun from "../../assets/sun.png";
import moon from "../../assets/moon.png";
import cart from "../../assets/cart.png";
import userIcon from "../../assets/user.png";
import burgerMenu from "../../assets/burgerManu.png";

const Header = ({
  logoImg,
  logoText,
  navLinks,
  actionText,
  textColor,
  actionBtnBgColor,
  btnAction,
  selectedNavIndex,
  setSelectedNavIndex,
  handleNavLinkClick,
  darkMode,
  setDarkMode,
  animateCart,
  currentUser,
  logOutHandler,
  iconClickHandler,
  setToggleSideOverlay,
  cartCount
}) => {
  const [showCart, setShowCart] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const [isCountUpdated , setIsCountUpdated] = useState(false);


  
  return (
    <motion.header
      className={`align- header-comp ${darkMode ? "dark-mode" : ""}`}
    >
      {/* LOGO */}
      {logoImg ? (
        <motion.div
          initial={{ top: "-100px", opacity: 0 }}
          animate={animations.logo}
          style={{ color: darkMode ? "white" : "black" }}
        >
          <img
            src={logoImg}
            alt="logo"
            className={
              darkMode
                ? "inverted-image logo-img sportsgate-logo"
                : "logo-img sportsgate-logo"
            }
          />
        </motion.div>
      ) : (
        <motion.div
          className="logo"
          initial={{ top: "-100px" }}
          animate={animations.logo}
          style={{
            color: darkMode ? "white" : "black",
          }}
        >
          <p>{logoText}</p>
        </motion.div>
      )}

      {/* DESKTOP NAV */}
      <motion.nav
        initial={{ left: "-100px", opacity: 0 }}
        animate={animations.nav}
        className="desktop"
      >
        <ul>
          {navLinks.map((link, index) => (
            <motion.li
              key={index}
              className={index === selectedNavIndex ? "selected" : ""}
              onClick={() => handleNavLinkClick(index)}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              animate={
                selectedNavIndex === index
                  ? { color: "#fbf008" }
                  : { color: !darkMode ? "black" : "white" }
              }
            >
              <p>{link}</p>
            </motion.li>
          ))}
        </ul>
      </motion.nav>

      {/* ACTIONS */}
      <motion.div
        className="flex align-items-center justify-canter bold nav-actions"
        initial={{ top: "-100px", opacity: 0 }}
        animate={animations.langueAndSignUp}
        style={{ color: darkMode ? "black" : "black" }}
      >
        {/* CART */}
        <motion.div
          className="langue mx-20 relative cart-icon"
          initial={{ borderColor: darkMode ? "red" : "black" }}
          animate={{ borderColor: darkMode ? "white" : "black" }}
          onClick={iconClickHandler}
        >

          <motion.div className="cart-count-circle absolute bg-red"
            initial={{scale:1}}
            animate={!animateCart ? { scale: 1 } : { scale: 1.5 }}
          
          >
            <p className="small-text">{cartCount}</p>
          </motion.div>
          <motion.img
            src={cart}
            alt="cart"
            className={
              darkMode
                ? "langue-img cart-img inverted-image"
                : "langue-img cart-img"
            }
          />
        </motion.div>

        {/* DARK MODE TOGGLE */}
        <motion.div
          className="langue"
          initial={{ borderColor: darkMode ? "white" : "black" }}
          animate={{ borderColor: darkMode ? "white" : "black" }}
          onClick={darkMode ? setDarkMode.disable : setDarkMode.enable}
        >
          {!darkMode ? (
            <img src={moon} alt="moon" className="langue-img" />
          ) : (
            <img src={sun} alt="sun" className="langue-img" />
          )}
        </motion.div>

        {/* MOBILE USER ICON */}
        {currentUser && (
          <img
            alt=""
            src={userIcon}
            className="pointer mobile user-icon langue small-icon"
            onClick={(e) => {
              e.stopPropagation();
              setToggleSideOverlay(true);
            }}
          />
        )}

        {currentUser && (
          <img
            alt=""
            src={userIcon}
            className="pointer  user-icon web langue-img langue small-icon"
            onClick={(e) => {
              e.stopPropagation();
              setToggleSideOverlay(true);
            }}
          />
        )}

        {/* LOGIN / USER */}
        <motion.div
          className={
            currentUser ? "bold logOut-Btn action-button" : "bold action-button"
          }
          initial={{
            actionBtnBgColor: "#fbf008",
            color: darkMode ? "black" : "white",
          }}
          animate={{
            backgroundColor: "#fbf008",
            color: darkMode ? "white" : "white",
          }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
          onClick={() => {
            if (currentUser) {
              var user = currentUser.name.toString();
            }
            currentUser
              ? Swal.fire({
                  title: "Log Out",
                  text: user + ", Do you want to log Out",
                  icon: "warning",
                  iconColor: "#fbf008",
                  confirmButtonText: "confirm",
                  confirmButtonColor: "#fbf008",
                  scrollbarPadding: true,
                  customClass: {
                    popup: "popup",
                    icon: "custom-icon-class",
                    container: "popup-container",
                  },
                }).then((res) => {
                  if (res.isConfirmed) logOutHandler();
                })
              : btnAction(2);
          }}
        >
          {currentUser ? (
            <motion.p
              className="btn"
              initial={{ opacity: 0 }}
              animate={currentUser ? { opacity: 1 } : { opacity: 0 }}
            >
              {currentUser.name} | Log Out
            </motion.p>
          ) : (
            <motion.p
              className="btn"
              initial={{ opacity: 1 }}
              animate={currentUser ? { opacity: 0 } : { opacity: 1 }}
            >
              {actionText}
            </motion.p>
          )}
        </motion.div>

        {/* MOBILE MENU ICON */}
        <motion.div
          className="mobile menu-icon mx-10 mobile"
          onClick={() => setShowMobileMenu(true)}
        >
          <img
            src={burgerMenu}
            alt=""
            className={darkMode ? " inverted-image" : ""}
          />
        </motion.div>
      </motion.div>

      {/* MOBILE NAV OVERLAY */}
      {/* MOBILE NAV OVERLAY */}
      <AnimatePresence>
        {showMobileMenu && (
          <motion.div
            className="mobile mobile-nav-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100vh",
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 999999999,
            }}
            onClick={() => setShowMobileMenu(false)} // ✅ OVERLAY CLICK WORKS NOW
          >
            <motion.div
              className="mobile-nav-content"
              initial={{ y: "-100%" }}
              animate={{ y: "0%" }}
              exit={{ y: "-100%" }}
              transition={{ duration: 0.4, ease: "easeOut" }}
              style={{
                height: "fit-content",
                width: "100%",
                position: "absolute",
                top: "0px",
                paddingBottom: "10ppx",
                backgroundColor: darkMode ? " rgba(22, 24, 30, 1)" : "#fff",
              }}
              onClick={(e) => e.stopPropagation()} // ✅ prevents closing when clicking inside
            >
              {/* ✅ MOBILE TOP BAR */}
              <div
                style={{
                  width: "100%",
                  height: "65px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderBottom: "1px solid rgba(255,255,255,0.1)",
                  position: "relative",
                }}
              >
                {/* centered logo */}
                <img
                  src={logoImg}
                  alt="logo"
                  style={{
                    width: "110px",
                    objectFit: "contain",
                    filter: darkMode ? "invert(1)" : "none",
                  }}
                />

                {/* close icon */}
                <span
                  onClick={() => setShowMobileMenu(false)}
                  style={{
                    position: "absolute",
                    right: "20px",
                    fontSize: "20px",
                    cursor: "pointer",
                    color: darkMode ? "white" : "black",
                    fontWeight: "bold",
                  }}
                >
                  ✕
                </span>
              </div>

              {/* ✅ NAV LINKS */}
              <ul className="mobile-nav-links flex-column align-center">
                {navLinks.map((link, index) => (
                  <motion.div
                    key={index}
                    className={`mobile-link  small-text bold ${
                      selectedNavIndex === index ? "selected" : ""
                    }`}
                    onClick={() => {
                      handleNavLinkClick(index);
                      setShowMobileMenu(false);
                    }}
                    style={{
                      padding: "15px 0",
                      fontSize: "1rem",
                      color: darkMode ? "white" : "black",
                      borderBottom: "1px solid rgba(255,255,255,0.05)",
                      width: "100%",
                      textAlign: "center",
                    }}
                    whileTap={{ scale: 0.95 }}
                  >
                    {link}
                  </motion.div>
                ))}
              </ul>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Header;
